import React from "react";
import { canEditProps, GradeShowType } from "../../../service/score";

export interface ScoreContextProps {
    Operator: canEditProps | null;
    ReloadOperator: () => void;
    OperatorLoading: boolean;
    ShowType: GradeShowType | null; //表格中的显示设置
    ReloadShowType: () => void;
    ShowTypeLoading: boolean;
}

const ScoreBaseContext = React.createContext<ScoreContextProps>({
    Operator: null,
    OperatorLoading: false,
    ReloadOperator: () => null,
    ShowType: null,
    ReloadShowType: () => null,
    ShowTypeLoading: false
});

export default ScoreBaseContext;
